export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageVisits.vue?vue&type=template&id=2a6dc10c&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/CommercialManagement/ManageVisits.vue?vue&type=template&id=2a6dc10c&
// module id = null
// module chunks = 